import React, { useEffect, useState } from 'react'
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { DigitalVaultOperationalReportView } from '../../views';
import { DigitalVaultService, LocalStorageService } from '../../../services';
import moment from "moment";

const DigitalVaultOperationalReportAction = (props) => {
    const {
        toggleCompletedRequesting,
        toggleLoadingRequesting,
        toggleErrorRequesting,
        isUser,
        selectedCompanyId,
        setSelectedDocumentId,
        t
    } = props;

    const url = process.env.REACT_APP_MIFIRMA_API;
    const localStorageService = new LocalStorageService();
    const token = localStorageService.getLocalStorageItem("token").idToken;
    let timezone = localStorageService.getLocalStorageItem("timezone");

    const digitalVaultService = new DigitalVaultService(url);

    const [isLoading, setIsLoading] = useState(true);

    const [documentsToExpire, setDocumentsToExpire] = useState([]);
    const [expiredDocuments, setExpiredDocuments] = useState([]);
    const [totalAlerts, setTotalAlerts] = useState([]);

    const loadReport = async () => {
        setIsLoading(true);

        try {
            const response = await digitalVaultService.getOperationalReport(token, timezone, selectedCompanyId == 0 ? null : selectedCompanyId)
            if (response.statusCode == 200 && response.data) {
                let preferredLanguage = localStorageService.getLocalStorageItem("preferredLanguage")
                let language = preferredLanguage || "es"
                moment.locale(language);
                response.data.docsToExpire.map((doc) => {
                    let date = moment(doc.validation).format("DD/MMM/YYYY")
                    date = date.replaceAll(".", "")
                    date = date.toLocaleLowerCase()
                    doc.validation = date
                    return doc
                })

                setDocumentsToExpire(response.data.docsToExpire);
                setExpiredDocuments(response.data.docsExpired);
                setTotalAlerts(response.data.totalAlerts);
            } else {
                throw new Error(response.message || "Ocurrió un error el dashboard operacional.")
            }
            setIsLoading(false);
        } catch (e) {
            toggleErrorRequesting(true, e.message, 4000, true)
        }
    }

    useEffect(() => {
        loadReport();
    }, [selectedCompanyId])


    return (
        <DigitalVaultOperationalReportView
            t={t}
            isLoading={isLoading}
            isUser={isUser}
            setSelectedDocumentId={setSelectedDocumentId}
            documentsToExpire={documentsToExpire}
            expiredDocuments={expiredDocuments}
            totalAlerts={totalAlerts}
        />
    )
}

export default withRouter(withTranslation()(DigitalVaultOperationalReportAction));